<template>
  <v-container>
    <v-row>
      <v-col :order-md="opposite ? 1 : 2" cols="12" md="6" class="px-16">
        <v-row>
          <v-col>
            <v-img
              :aspect-ratio="aspectRatio"
              :sizes="imgResp.sizes"
              :src="imgResp.src"
              :srcset="imgResp.srcset"
              alt="Photo for why benefits"
              cover
              max-height="800"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <TitleParagraphCard :value="value" color="transparent" />
          </v-col>
        </v-row>
      </v-col>

      <v-col
        v-if="value.benefit_items && value.benefit_items.length"
        :order-md="opposite ? 2 : 1"
        cols="12"
        md="6"
      >
        <v-row v-for="benefitItem in value.benefit_items" :key="benefitItem.id">
          <v-col cols="auto">
            <v-avatar
              v-if="typeof benefitItem.icon === 'string'"
              class="ma-2"
              size="70"
              style="border-width: 2px"
              rounded="0"
              variant="outlined"
            >
              <v-icon :icon="`hdl:${benefitItem.icon}`" size="44" />
            </v-avatar>
          </v-col>

          <v-col>
            <TitleParagraphBlock
              title-class="text-h5 font-weight-medium"
              title-tag="h3"
              :value="benefitItem"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { toRef } from 'vue'
import { useImgResponsive } from '#root/lib/img'

const props = defineProps({
  opposite: {
    default: false,
    type: Boolean
  },
  value: {
    required: true,
    type: Object
  }
})

const aspectRatio = 2 / 1
const imgResp = useImgResponsive(
  toRef(() => ({
    aspectRatio,
    image: props.value.image,
    sizes: {
      lg: '1600px'
    }
  }))
)
</script>
